module.exports = __webpack_public_path__ + "img/imgcreatividad2.5eaa1732.png";